<template>
    <div class="makemodelstepone">
        <div class="topheader">
            <div class="topheaderleft">
                欢迎您---{{username}}
            </div>
            <div class="topheaderright">
               <div class="back" @click="Back">
                   <i class="el-icon-arrow-left"></i>
                   <span>返回</span>
               </div>
               <div class="outlogin" @click="OutLogin">
                    <i class="el-icon-switch-button"></i>
                    <span>退出</span>
               </div>
            </div>

        </div>


        <div class="content">
            <div class="steps">
                <ul>
                    <li @click="ResLinkTo('/resmodelone')">
                        <div class="steptop">
                            <span class="line"></span>
                            <span class="stepsicon">1</span>
                            <span class="line"></span>
                        </div>
                        <div class="stepbottom">
                            添加模型基本信息

                        </div>
                        
                    </li>
                    <li class="active">
                        <div class="steptop">
                            <span class="line"></span>
                            <span class="stepsicon">2</span>
                            <span class="line"></span>
                        </div>
                        <div class="stepbottom">
                            添加作物周期农事

                        </div>
                        
                    </li>
                </ul>

            </div>

            <div class="addcontent">
                <div class="addtips">
                    <div class="tipscontent">
                        <span class="addtipsicon" :style="addtipsicon"></span>
                        <span>作物农事信息</span>
                    </div>
                    <div class="adbtns">
                        <el-button type="success" class="addkh-btn" @click="AddNsVisible=true">新增农事</el-button>
                    </div>
                    
                    

                </div>



                <el-table :data="NsListData" border style="width: 100%">
                    <el-table-column
                    prop="bid"
                    label="序号"
                    align="center" >
                    <template slot-scope="scope"> 
                        <span>{{scope.$index+1}}</span>
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop="zq_mc"
                    label="周期名称"
                    align="center" >
                    </el-table-column>
                    <el-table-column
                    prop="work_name"
                    label="农事事项名称" align="center">
                    </el-table-column>
                    <el-table-column
                    prop="pai_xu"
                    label="排序"
                    :show-overflow-tooltip="true" align="center"> 
                    </el-table-column>
                    <el-table-column
                    prop="work_desc"
                    label="农事事项指导"
                    :show-overflow-tooltip="true" align="center">
                    </el-table-column>
                    <el-table-column label="操作" align="center" >
                        <template slot-scope="scope">
                          <!-- <el-button size="mini" type="success" icon="el-icon-view" @click="SeeDet(scope.row.id)" title="查看"></el-button> -->
                          <el-button
                          size="mini"
                          type="primary"
                          icon="el-icon-edit"
                          @click="EditNs(scope.row.id)" title="修改"></el-button>
                          <el-button
                          size="mini"
                          type="danger"
                          icon="el-icon-delete"
                          @click="DeleteNs(scope.row.id)" title="删除"></el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="block pages" >
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page.sync="pagenum"
                      :page-size="limit"
                      layout="prev, pager, next, jumper"
                      :total="nstotal">
                    </el-pagination>
                </div>

            </div>

        </div>


        <div class="nextbtns">
            <el-button type="primary" @click="LinkTo" class="nextbtn">返回模型列表</el-button>
        </div>
<!--添加作物周期弹出框-->
<el-dialog title="新增农事信息" :visible.sync="AddNsVisible" width="60%">
    <el-form :model="AddNsForm" :rules="addnsrules" ref="AddNsForm" label-width="140px" class="demo-ruleForm" :inline="true">
        <el-form-item label="周期名称">
            <el-select v-model="AddNsForm.addzqmc" placeholder="请选择周期名称" prop="addzqmc">
                <el-option :label="item.zqMc" :value="item.zqMc+','+item.zqNum" v-for="(item, index) in zqmcArr" :key="index"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="农事事项">
            <el-select v-model="AddNsForm.addnssx" placeholder="请选择农事事项" prop="addnssx">
                <el-option :label="item.name" :value="item.name" v-for="(item, index) in nssxArr" :key="index"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="排序(升序)" prop="addnspx">
            <el-input v-model="AddNsForm.addnspx"></el-input>
        </el-form-item>
       
        
        
    </el-form>   
    <div class="syjdimg">
        <span class="syjdspan">农事指导</span>
        <el-input type="textarea" :rows="2" placeholder="请输入农事指导" v-model="AddNsForm.addnszd" style="width: 85%;"></el-input>
        
        
    </div>


    <div class="addtips">
        <div class="tipscontent">
            <span class="addtipsicon" :style="addtipsicon"></span>
            <span>作物农事信息</span>
        </div>
        <div class="adbtns">
            <el-button type="success" class="addkh-btn" @click="AddCfTjVisible=true">新增条件</el-button>
        </div>
    </div>

    <el-table :data="TjListData" border style="width: 100%">
        <el-table-column
        label="序号"
        align="center" >
        <template slot-scope="scope"> 
            <span>{{scope.$index+1}}</span>
        </template>
        </el-table-column>
        <el-table-column
        prop="tjMc"
        label="条件名称"
        align="center" >
        </el-table-column>
        <el-table-column
        prop="maxZhi"
        label="最高值" align="center" >
        </el-table-column>
        <el-table-column
        prop="minZhi"
        label="最低值"
        :show-overflow-tooltip="true"
        align="center" >
        </el-table-column>
        <el-table-column
        prop="tjGx"
        label="条件关系"
        :show-overflow-tooltip="true" align="center" >
        </el-table-column>
        <el-table-column label="操作" align="center" >
            <template slot-scope="scope">
              <el-button
              size="mini"
              type="primary"
              icon="el-icon-edit"
              @click="EditTj(scope.$index)" title="修改"></el-button>
              <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="DeleteTj(scope.$index)" title="删除"></el-button>
            </template>
        </el-table-column>
    </el-table>
    <div class="addzwbtns">

        <el-button type="primary" @click="AddNsBtn('AddNsForm')">确定</el-button>
        <el-button @click="resetForm('AddNsForm')">重置</el-button>
    </div>
    
    
    
    
    </el-dialog>
    <el-dialog title="新增农事触发条件" :visible.sync="AddCfTjVisible" width="60%">
        <el-form :model="AddCfTjForm" :rules="addtjrules" ref="AddCfTjForm" label-width="140px" class="demo-ruleForm" :inline="true">
            <el-form-item label="条件名称" prop="addtjmc">
                <el-input v-model="AddCfTjForm.addtjmc"></el-input>
            </el-form-item>
            <el-form-item label="条件关系">
                <el-select v-model="AddCfTjForm.addtjgx" placeholder="请选择条件关系" prop="addtjgx">
                    <el-option :label="item.name" :value="item.name" v-for="(item, index) in tjgxArr" :key="index"></el-option> 
                </el-select>
            </el-form-item>
            <el-form-item label="最高值" prop="addmax">
                <el-input v-model="AddCfTjForm.addmax"></el-input>
            </el-form-item>
            <el-form-item label="最低值" prop="addmin">
                <el-input v-model="AddCfTjForm.addmin"></el-input>
            </el-form-item>
           
            
            
        </el-form>   

        <div class="addzwbtns">
    
            <el-button type="primary" @click="AddTjBtn('AddCfTjForm')">确定</el-button>
            <el-button @click="resetTjForm('AddCfTjForm')">重置</el-button>
        </div>
    </el-dialog>

    <el-dialog title="修改农事触发条件" :visible.sync="ResCfTjVisible" width="60%">
        <el-form :model="ResCfTjForm" :rules="restjrules" ref="ResCfTjForm" label-width="140px" class="demo-ruleForm" :inline="true">
            <el-form-item label="条件名称" prop="restjmc">
                <el-input v-model="ResCfTjForm.restjmc"></el-input>
            </el-form-item>
            <el-form-item label="条件关系">
                <el-select v-model="ResCfTjForm.restjgx" placeholder="请选择条件关系" prop="restjgx">
                    <el-option :label="item.name" :value="item.name" v-for="(item, index) in tjgxArr" :key="index"></el-option> 
                </el-select>
            </el-form-item>
            <el-form-item label="最高值" prop="resmax">
                <el-input v-model="ResCfTjForm.resmax"></el-input>
            </el-form-item>
            <el-form-item label="最低值" prop="resmin">
                <el-input v-model="ResCfTjForm.resmin"></el-input>
            </el-form-item>
           
            
            
        </el-form>   

        <div class="addzwbtns">
    
            <el-button type="primary" @click="ResTjBtn('ResCfTjForm')">确定</el-button>
            <el-button @click="resetTjForm('ResCfTjForm')">重置</el-button>
        </div>
    </el-dialog>




<!--修改作物周期弹出框-->
<el-dialog title="修改农事信息" :visible.sync="XgNsVisible" width="60%">
    <el-form :model="XgNsForm" :rules="xgnsrules" ref="XgNsForm" label-width="140px" class="demo-ruleForm" :inline="true">
        <el-form-item label="周期名称">
            <el-select v-model="XgNsForm.xgzqmc" placeholder="请选择周期名称" prop="xgzqmc">
                <el-option :label="item.zqMc" :value="item.zqMc+','+item.zqNum" v-for="(item, index) in zqmcArr" :key="index"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="农事事项">
            <el-select v-model="XgNsForm.xgnssx" placeholder="请选择农事事项" prop="xgnssx">
                <el-option :label="item.name" :value="item.name" v-for="(item, index) in nssxArr" :key="index"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="排序(升序)" prop="xgnspx">
            <el-input v-model="XgNsForm.xgnspx"></el-input>
        </el-form-item>
       
        
        
    </el-form>   
    <div class="syjdimg">
        <span class="syjdspan">农事指导</span>
        <el-input type="textarea" :rows="2" placeholder="请输入农事指导" v-model="XgNsForm.xgnszd" style="width: 85%;"></el-input>
        
        
    </div>


    <div class="addtips">
        <div class="tipscontent">
            <span class="addtipsicon" :style="addtipsicon"></span>
            <span>作物农事信息</span>
        </div>
        <!-- <div class="adbtns">
            <el-button type="success" class="addkh-btn" @click="XgAddCfTjVisible=true">新增条件</el-button>
        </div> -->
    </div>

    <el-table :data="XgTjListData" border style="width: 100%">
        <el-table-column
        label="序号"
        align="center" >
        <template slot-scope="scope"> 
            <span>{{scope.$index+1}}</span>
        </template>
        </el-table-column>
        <el-table-column
        prop="tjMc"
        label="条件名称"
        align="center" >
        </el-table-column>
        <el-table-column
        prop="maxZhi"
        label="最高值" align="center" >
        </el-table-column>
        <el-table-column
        prop="minZhi"
        label="最低值"
        :show-overflow-tooltip="true"
        align="center" >
        </el-table-column>
        <el-table-column
        prop="tjGx"
        label="条件关系"
        :show-overflow-tooltip="true" align="center" >
        </el-table-column>
        <el-table-column label="操作" align="center" >
            <template slot-scope="scope">
              <el-button
              size="mini"
              type="primary"
              icon="el-icon-edit"
              @click="EditXgTj(scope.$index,scope.row.id)" title="修改"></el-button>
              <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="DeleteXgTj(scope.$index,scope.row.id)" title="删除"></el-button>
            </template>
        </el-table-column>
    </el-table>
    <div class="addzwbtns">

        <el-button type="primary" @click="XgNsBtn('XgNsForm')">确定</el-button>
        <el-button @click="XgresetForm('XgNsForm')">重置</el-button>
    </div>
    
    
    
    
    </el-dialog>


    <el-dialog title="新增农事触发条件" :visible.sync="XgAddCfTjVisible" width="60%">
        <el-form :model="XgAddCfTjForm" :rules="xgaddtjrules" ref="XgAddCfTjForm" label-width="140px" class="demo-ruleForm" :inline="true">
            <el-form-item label="条件名称" prop="xgaddtjmc">
                <el-input v-model="XgAddCfTjForm.xgaddtjmc"></el-input>
            </el-form-item>
            <el-form-item label="条件关系">
                <el-select v-model="XgAddCfTjForm.xgaddtjgx" placeholder="请选择条件关系" prop="xgaddtjgx">
                    <el-option :label="item.name" :value="item.name" v-for="(item, index) in tjgxArr" :key="index"></el-option> 
                </el-select>
            </el-form-item>
            <el-form-item label="最高值" prop="xgaddmax">
                <el-input v-model="XgAddCfTjForm.xgaddmax"></el-input>
            </el-form-item>
            <el-form-item label="最低值" prop="xgaddmin">
                <el-input v-model="XgAddCfTjForm.xgaddmin"></el-input>
            </el-form-item>
           
            
            
        </el-form>   

        <div class="addzwbtns">
    
            <el-button type="primary" @click="XgAddTjBtn('XgAddCfTjForm')">确定</el-button>
            <el-button @click="XgAddresetTjForm('XgAddCfTjForm')">重置</el-button>
        </div>
    </el-dialog>


    <el-dialog title="修改农事触发条件" :visible.sync="XgCfTjVisible" width="60%">
        <el-form :model="XgCfTjForm" :rules="xgtjrules" ref="XgCfTjForm" label-width="140px" class="demo-ruleForm" :inline="true">
            <el-form-item label="条件名称" prop="xgtjmc">
                <el-input v-model="XgCfTjForm.xgtjmc"></el-input>
            </el-form-item>
            <el-form-item label="条件关系">
                <el-select v-model="XgCfTjForm.xgtjgx" placeholder="请选择条件关系" prop="xgtjgx">
                    <el-option :label="item.name" :value="item.name" v-for="(item, index) in tjgxArr" :key="index"></el-option> 
                </el-select>
            </el-form-item>
            <el-form-item label="最高值" prop="xgmax">
                <el-input v-model="XgCfTjForm.xgmax"></el-input>
            </el-form-item>
            <el-form-item label="最低值" prop="xgmin">
                <el-input v-model="XgCfTjForm.xgmin"></el-input>
            </el-form-item>
           
            
            
        </el-form>   

        <div class="addzwbtns">
    
            <el-button type="primary" @click="XgTjBtn('XgCfTjForm')">确定</el-button>
            <el-button @click="XgresetTjForm('XgCfTjForm')">重置</el-button>
        </div>
    </el-dialog>

    </div>
  </template>
  
  <script>
    import storage from '../../Storage/storage.js';
    export default {
      name: "Makemodelsteptwo",
      data() {
        return {
         username:'',
         addtipsicon:{
            backgroundImage: "url(./static/images/addicon.png)",
         },
         zqmcArr:[],
         nssxArr:[],
         activezqnum:'',
         NsListData: [],
         pagenum:1,
         limit:10,
         nstotal:0,

         //添加作物弹出框
AddNsVisible:false,
AddNsForm: {
    addzqmc: '',
    addzqnum:'',
    addnssx:'',
    addnspx:'',
    addnszd:'',   
    },

addnsrules: {
    addzqmc:[
        { required: true, message: '请选择周期名称', trigger: 'change' },
    ],
    addnssx:[
        { required: true, message: '请选择农事事项', trigger: 'change' },
    ],
    addnspx:[
    { required: true, message: '请输入排序', trigger: 'blur' },
    ], 
},


    addzwimg:'',
    addzwimgurl:'./static/images/plus.png',
    addzwimgname:'',
    addZwlxArr:[],

    


    
    AddZwImgVisible:false,
    ZwImgArr:[],
    requetImgUrl:'',
    upimgurl:'',
    myHeaders: {
                token: ""
            }, 

    TjListData:[],
    AddCfTjVisible:false,
    tjgxArr:[],
    AddCfTjForm: {
        addtjmc: '',
        addtjgx:'',
        addmax:'',
        addmin:'',   
    },

    addtjrules: {
        addtjmc:[
          { required: true, message: '请输入条件名称', trigger: 'blur' },
        ],
        addtjgx:[
          { required: true, message: '请选择条件关系', trigger: 'change' },
        ],
        addmax:[
          { required: true, message: '请输入最高值', trigger: 'blur' },
        ],
        addmin:[
          { required: true, message: '请输入最低值', trigger: 'blur' },
        ],  
    },



    ResCfTjVisible:false,
    ResCfTjForm: {
        restjmc: '',
        restjgx:'',
        resmax:'',
        resmin:'',   
    },

    restjrules: {
        restjmc:[
          { required: true, message: '请输入条件名称', trigger: 'blur' },
        ],
        restjgx:[
          { required: true, message: '请选择条件关系', trigger: 'change' },
        ],
        resmax:[
          { required: true, message: '请输入最高值', trigger: 'blur' },
        ],
        resmin:[
          { required: true, message: '请输入最低值', trigger: 'blur' },
        ],  
    },

    xgnsid:'',
    XgTjListData:[],
    XgAddCfTjVisible:false,
    XgAddCfTjForm: {
        xgaddtjmc: '',
        xgaddtjgx:'',
        xgaddmax:'',
        xgaddmin:'',   
    },
    xgaddtjrules: {
        xgaddtjmc:[
          { required: true, message: '请输入条件名称', trigger: 'blur' },
        ],
        xgaddtjgx:[
          { required: true, message: '请选择条件关系', trigger: 'change' },
        ],
        xgaddmax:[
          { required: true, message: '请输入最高值', trigger: 'blur' },
        ],
        xgaddmin:[
          { required: true, message: '请输入最低值', trigger: 'blur' },
        ],  
    },


    xgtjid:'',
    XgCfTjVisible:false,
    XgCfTjForm: {
        xgtjmc: '',
        xgtjgx:'',
        xgmax:'',
        xgmin:'',   
    },
    xgtjrules: {
        xgtjmc:[
          { required: true, message: '请输入条件名称', trigger: 'blur' },
        ],
        xgtjgx:[
          { required: true, message: '请选择条件关系', trigger: 'change' },
        ],
        xgmax:[
          { required: true, message: '请输入最高值', trigger: 'blur' },
        ],
        xgmin:[
          { required: true, message: '请输入最低值', trigger: 'blur' },
        ],  
    },




//修改农事信息
XgNsVisible:false,
XgNsForm: {
    xgzqmc: '',
    xgzqnum:'',
    xgnssx:'',
    xgnspx:'',
    xgnszd:'',   
    },

xgnsrules: {
    xgzqmc:[
        { required: true, message: '请选择周期名称', trigger: 'change' },
    ],
    xgnssx:[
        { required: true, message: '请选择农事事项', trigger: 'change' },
    ],
    xgnspx:[
    { required: true, message: '请输入排序', trigger: 'blur' },
    ], 
},





        }
    
      },
      methods: {
        Back(){
            this.$router.go(-1);
        },
        OutLogin(){
            storage.remove('token');
           storage.remove('userid');
           storage.remove('username');
           this.$router.push({
                    path: '/',
                    query: {
                    }
            }) 
        },
        LinkTo(){
            this.$router.push({
                  path: 'seemodel',
                  query: {
                    
                  }
            }) 
        },
        GetZqMc(modenum){
            var LookZwZq=this.GLOBAL.LookZwZq;
                this.$http.post(LookZwZq,{num:modenum},{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                    //   console.log(res);
                      this.zqmcArr=res.body.data.list; 
                      
                                         
                },function(err){})
        },
        GetNsSx(){
            var NsSxList=this.GLOBAL.NsSxList;
                this.$http.post(NsSxList,{},{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                    //   console.log(res);
                      this.nssxArr=res.body.list; 
                      
                                         
                },function(err){})
        },
        GetTjGx(){
            var TjGxList=this.GLOBAL.TjGxList;
                this.$http.post(TjGxList,{},{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                    //   console.log(res);
                      this.tjgxArr=res.body.list; 
                      
                                         
                },function(err){})
        },
        AddNsBtn(formName){
            this.$refs[formName].validate((valid) => {
            if (valid) {
                // console.log(this.AddNsForm.addzqmc+','+this.AddNsForm.addnssx+this.AddNsForm.addnspx+','+this.AddNsForm.addnszd);
                // console.log(this.TjListData);
                var Addzwzq=this.GLOBAL.Addzwzq;
                this.$http.post(Addzwzq,{userID:this.userid,zqMc:this.AddNsForm.addzqmc.split(',')[0],workName:this.AddNsForm.addnssx,paiXu:this.AddNsForm.addnspx,
                    zqNum:this.AddNsForm.addzqmc.split(',')[1],workDesc:this.AddNsForm.addnszd,modeNum:this.$route.query.modenum,chufalist:this.TjListData
                },{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                    //   console.log(res); 
                      if(res.body.msg=="success"){
                          this.AddNsVisible=false;
                          this.GetNsList(this.$route.query.modenum,this.activezqnum,this.pagenum,this.limit);
                          this.AddNsForm.addzqmc='';
                          this.AddNsForm.addzqnum='';
                          this.AddNsForm.addnssx='';
                          this.AddNsForm.addnspx='';
                          this.AddNsForm.addnszd='';
                          this.TjListData=[];

                      }
                      
                                         
                },function(err){})


            } else {
              return false;
            }
          });
        },
        AddTjBtn(formName){
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.AddCfTjVisible=false;
                this.TjListData.push({         
                    tjMc:this.AddCfTjForm.addtjmc,
                    tjGx:this.AddCfTjForm.addtjgx,
                    maxZhi:this.AddCfTjForm.addmax,
                    minZhi:this.AddCfTjForm.addmin
               })

                this.AddCfTjForm.addtjmc='';
                this.AddCfTjForm.addtjgx='';
                this.AddCfTjForm.addmax='';
                this.AddCfTjForm.addmin='';
            } else {
              return false;
            }
          });

        },
        DeleteTj(index){
            this.TjListData.splice(index,1);
        },
        EditTj(index){
            this.ResCfTjVisible=true;
            this.resindex=index;
            this.ResCfTjForm.restjmc=this.TjListData[index].tjMc;
            this.ResCfTjForm.restjgx=this.TjListData[index].tjGx;
            this.ResCfTjForm.resmax=this.TjListData[index].maxZhi;
            this.ResCfTjForm.resmin=this.TjListData[index].minZhi;
        },
        ResTjBtn(formName){
            this.ResCfTjVisible=false;
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$set(this.TjListData, this.resindex,  
                        {         
                        tjMc:this.ResCfTjForm.restjmc,
                        tjGx:this.ResCfTjForm.restjgx,
                        maxZhi:this.ResCfTjForm.resmax,
                        minZhi:this.ResCfTjForm.resmin
                        }
                )
            } else {
            return false;
            }
            });

        },
        GetNsList(modenum,activezqnum,pagenum,limit){
            var Looknslist=this.GLOBAL.Looknslist;
                this.$http.post(Looknslist,{num:modenum,types:activezqnum,page:pagenum,limit:limit},{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                    //   console.log(res);
                      this.NsListData=res.body.data.list; 
                    this.nstotal=parseInt(res.body.data.total);
                                         
                },function(err){})

        },
        handleSizeChange(val) {
          // console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
          // console.log(`当前页: ${val}`);
          this.pagenum=val;
          this.GetNsList(this.$route.query.modenum,this.activezqnum,this.pagenum,this.limit);
        },
        EditNs(id){
            this.XgNsVisible=true;
            this.xgnsid=id;
            var Lookzqnongshi=this.GLOBAL.Lookzqnongshi;
                this.$http.post(Lookzqnongshi,{id:id},{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                    //   console.log(res);
                      this.XgNsForm.xgzqmc=res.body.data.jbinfo.zqMc;
                      this.XgNsForm.xgzqnum=res.body.data.jbinfo.zqNum;
                      this.XgNsForm.xgnssx=res.body.data.jbinfo.workName;
                      this.XgNsForm.xgnspx=res.body.data.jbinfo.paiXu;
                      this.XgNsForm.xgnszd=res.body.data.jbinfo.workDesc;


                      this.XgTjListData=res.body.data.list;
   
                                               
            },function(err){})



        },

        XgAddTjBtn(formName){
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.XgAddCfTjVisible=false;
                this.XgTjListData.push({         
                    tjMc:this.XgAddCfTjForm.xgaddtjmc,
                    tjGx:this.XgAddCfTjForm.xgaddtjgx,
                    maxZhi:this.XgAddCfTjForm.xgaddmax,
                    minZhi:this.XgAddCfTjForm.xgaddmin
               })

                this.XgAddCfTjForm.xgaddtjmc='';
                this.XgAddCfTjForm.xgaddtjgx='';
                this.XgAddCfTjForm.xgaddmax='';
                this.XgAddCfTjForm.xgaddmin='';
            } else {
              return false;
            }
          });

        },
        DeleteXgTj(index,id){
            this.XgTjListData.splice(index,1);
            var Deletechufa=this.GLOBAL.Deletechufa;
                this.$http.post(Deletechufa,{id:id},{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                    //   console.log(res); 
                                         
                },function(err){})

        },
        EditXgTj(index,id){
            this.XgCfTjVisible=true;
            this.xgindex=index;
            this.xgtjid=id;
            this.XgCfTjForm.xgtjmc=this.XgTjListData[index].tjMc;
            this.XgCfTjForm.xgtjgx=this.XgTjListData[index].tjGx;
            this.XgCfTjForm.xgmax=this.XgTjListData[index].maxZhi;
            this.XgCfTjForm.xgmin=this.XgTjListData[index].minZhi;
        },
        XgTjBtn(formName){
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$set(this.XgTjListData, this.xgindex,  
                        {         
                        tjMc:this.XgCfTjForm.xgtjmc,
                        tjGx:this.XgCfTjForm.xgtjgx,
                        maxZhi:this.XgCfTjForm.xgmax,
                        minZhi:this.XgCfTjForm.xgmin
                        }
                )

                var Updatechufa=this.GLOBAL.Updatechufa;
                this.$http.post(Updatechufa,{id:this.xgtjid,tjMc:this.XgCfTjForm.xgtjmc,tjGx:this.XgCfTjForm.xgtjgx,maxZhi:this.XgCfTjForm.xgmax,
                    minZhi:this.XgCfTjForm.xgmin
                },{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                    //   console.log(res); 
                      if(res.body.msg=="success"){
                        this.XgCfTjVisible=false;
                      }
                      
                                         
                },function(err){})


                
            } else {
              return false;
            }
          });

        },
        DeleteNs(id){
            var Deletenongshi=this.GLOBAL.Deletenongshi;
                this.$http.post(Deletenongshi,{id:id},{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                    //   console.log(res);
                    this.GetNsList(this.$route.query.modenum,this.activezqnum,this.pagenum,this.limit);
                                         
                },function(err){})
        },

        XgNsBtn(formName){
            this.$refs[formName].validate((valid) => {
            if (valid) {
                // console.log(this.AddNsForm.addzqmc+','+this.AddNsForm.addnssx+this.AddNsForm.addnspx+','+this.AddNsForm.addnszd);
                // console.log(this.TjListData);
                var Updatenongshi=this.GLOBAL.Updatenongshi;
                this.$http.post(Updatenongshi,{id:this.xgnsid,zqMc:this.XgNsForm.xgzqmc.split(',')[0],workName:this.XgNsForm.xgnssx,paiXu:this.XgNsForm.xgnspx,
                    zqNum:this.XgNsForm.xgzqmc.split(',')[1],workDesc:this.XgNsForm.xgnszd,modeNum:this.$route.query.modenum
                },{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                    //   console.log(res); 
                      if(res.body.msg=="success"){
                          this.XgNsVisible=false;
                          this.GetNsList(this.$route.query.modenum,this.activezqnum,this.pagenum,this.limit);

                      }
                      
                                         
                },function(err){})

            } else {
              return false;
            }
          });
        },
        ResLinkTo(address){
            this.$router.push({
                path:address ,
                query: {
                modenum:this.$route.query.modenum
                }
            }) 
        }
      },
      mounted(){
        this.username=storage.get('username');
        this.myHeaders.token=storage.get('token');
        this.GetZqMc(this.$route.query.modenum);
        this.GetNsSx();
        this.GetTjGx();
        this.GetNsList(this.$route.query.modenum,this.activezqnum,this.pagenum,this.limit);
      }
    }
  </script>
  
  <style  scoped>
    .topheader{
        width: 100%;
        height: 40px;
        background: #3a8ee6;
        display: flex;
    }
    .topheaderleft{
        width: 50%;
        height: 40px;
        padding-left: 20px;
        line-height: 40px;
        box-sizing: border-box;
        text-align: left;
        color: #ffffff;
        font-size: 16px;
    }
    .topheaderright{
        width: 50%;
        height: 40px;
        padding-right: 20px;
        line-height: 40px;
        box-sizing: border-box;
        color: #ffffff;
        font-size: 16px;
        display: flex;
        justify-content: flex-end;
    }
    .back{
        cursor: pointer;
        font-size: 14px;
    }
    .outlogin{
        margin-left: 20px;
        font-size: 14px;
        cursor: pointer;
    }
    .content{
        width: 80%;
        margin: 0 auto;
    }
    .steps{
        width: 100%;
        margin-top: 20px;
    }
    .steps ul{
        width: 100%;
        height: 70px;
        display: flex;
    }
    .steps ul li{
        width: 50%;
        height: 70px;
        display: flex;
        flex-wrap: wrap;

    }
    .steptop{
        width: 100%;
        height: 40px;
        display: flex;
    }
    .line{
        width: calc(50% - 20px);
        height: 10px;
        background: #eeeeee;
        margin-top: 15px;
    }
    .stepbottom{
        width: 100%;
        height: 30px;
        line-height: 30px;
        text-align: center;
       
    }

    .stepsicon{
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #eeeeee;
        display: block;
        border-radius: 30px;
        font-size: 16px;
        font-weight: bold;
        
    }

    .active .steptop .line{
        background: #4EB944;
    } 
    .active .steptop .stepsicon{
        background:#4EB944;
        color: #ffffff;
    }
    .active .stepbottom{
        color: #4EB944;
    }
    .addcontent{
        width: 100%;
    }
    .addtips{
        width: 100%;
        height: 40px;
        margin: 40px 0 20px 0;
        display: flex;
        justify-content: space-between;

    }
    .tipscontent{
        display: flex;
    }
    .addtipsicon{
        width: 20px;
        height: 20px;
        display: block;
        background-size: 100%;
        margin-right: 10px;
    }
    .addtips span{
        font-weight: bold;
    }
    .mxfrom{
        width: 100%;
    }
    .addmxfrom{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    .el-select /deep/  .el-input__inner{
  padding-right: 15px !important;
  width: auto !important;
}
.el-input--prefix /deep/ .el-input__inner{
  padding-right: 15px !important;
  width: auto !important;
}
/* .el-input--prefix /deep/ .el-input__inner{
padding-left: 15px !important;
} */

.el-input--suffix /deep/ .el-input__inner{
  padding: 0 15px;
}
.el-select /deep/ .el-input__inner{
  padding: 0 15px;
}
.mxtextarea{
    width: 100%;
}
.el-textarea{
    width: calc(100% - 140px);
}
.mxtextarea /deep/ .el-form-item__content{
    margin-left: 0px !important;
}
.el-table /deep/ th{
background:#eeeeee ;
border-color: #dddddd ;
color: #000000;
text-align: center;
}
.el-dropdown-link {
cursor: pointer;
color: #409EFF;
}
.syjdimg{
    display: flex;
    margin: 20px 0;
}
.syjdspan{
    width: 128px;
    padding: 0 12px 0 0;
    display: block;
    text-align: right;
}
.addzwimgsContent{
  width: 100px;
  height: 100px;
  border: 1px dashed #eeeeee;
}
.addzwimgsContent p{
  padding: 0px;
  background: #eeeeee;
  margin: 0px;
  text-align: center;
}
.pxss-save-qx{
    width: 30%;
    margin: 60px auto;
    display: flex;
    justify-content: center;

}
.pxss-save-qx /deep/.el-button--primary{
    color: #fff;
    background-color: #2cabe3;
    border-color: #2cabe3;
}
.syjdimgtarget{
    width: 100px;
    height: 100px;
}
.addzwbtns{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 40px;
}
.pages{
    text-align: right;
    margin-top: 10px;
}
.nextbtns{
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    margin: 40px 0;
}
.nextbtn{
    width: 120px;
}
  </style>
  


// WEBPACK FOOTER //
// src/components/SEEMODEL/resmodeltwo.vue